import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'countries';

// Action Types
export const types = {
  GET_COUNTRIES_ASYNC: createAsyncTypes(`${KEY}/GET_COUNTRIES_ASYNC`)
};

export interface Country {
  id: number;
  description: string;
  isoAlpha3Code: string;
  shortDesc: string;
}

export interface CountriesState {
  readonly countries: Country[] | null;
  readonly loading: boolean;
  readonly error: undefined | string;
}

export interface GetCountriesRequest {
  type: typeof types.GET_COUNTRIES_ASYNC.REQUEST;
}

export interface GetCountriesError {
  type: typeof types.GET_COUNTRIES_ASYNC.ERROR;
  payload: string;
}

export interface GetCountriesPending {
  type: typeof types.GET_COUNTRIES_ASYNC.PENDING;
  payload: boolean;
}

export interface GetCountriesSuccess {
  type: typeof types.GET_COUNTRIES_ASYNC.SUCCESS;
  payload: Country[];
}

export type CountryActionType = GetCountriesRequest | GetCountriesError | GetCountriesPending | GetCountriesSuccess;
